import { render, staticRenderFns } from "./Loading.component.vue?vue&type=template&id=4f2416ce&scoped=true"
import script from "./Loading.component.vue?vue&type=script&lang=ts"
export * from "./Loading.component.vue?vue&type=script&lang=ts"
import style0 from "./Loading.component.vue?vue&type=style&index=0&id=4f2416ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2416ce",
  null
  
)

export default component.exports